import React from "react";
import {gridConstants} from "./";

interface GridContainerProps {
    children?: React.ReactNode;
    className?: string;
    hasMarginX?: boolean;
    hasMarginY?: boolean;
    hasPaddingX?: boolean;
    hasPaddingY?: boolean;
    id?: string;
    isFlush?: boolean;
    isReverseOrder?: boolean;
    "data-testid"?: string;
}

export const GridContainer: React.FC<GridContainerProps> = ({
                           children,
                           className,
                           hasMarginX,
                           hasMarginY,
                           hasPaddingX,
                           hasPaddingY,
                           isFlush,
                       isReverseOrder
                       }: GridContainerProps) => {

    let classes = "grid-container grid-x";
    classes += className ? ` ${className}` : "";
    classes += hasMarginX ? ` ${gridConstants.class.GRID_MARGIN_X}` : "";
    classes += hasMarginY ? ` ${gridConstants.class.GRID_MARGIN_Y}` : "";
    classes += hasPaddingX ? ` ${gridConstants.class.GRID_PADDING_X}` : "";
    classes += hasPaddingY ? ` ${gridConstants.class.GRID_PADDING_Y}` : "";
    classes += isFlush ? ` ${gridConstants.class.GRID_FLUSH}` : "";
    classes += isReverseOrder ? ` ${gridConstants.class.GRID_REVERSE}` : "";

    return <div className={classes}>
        {children}
    </div>;
};
